export enum ReviewsRoutes {
  root = 'reviews',
  create = 'create',
  view = 'view',
}
